import { useState } from "react";
import { FormLabel, FormControl as Input } from "react-bootstrap";
import { Button, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import { useDispatch } from "react-redux";
import { Show } from "actions/SnackbarActions";

// mui icons
import CloseIcon from "@mui/icons-material/Close";
import SettingsIcon from "@mui/icons-material/Settings";
import { Post } from "utils/request";

const Section3Card = (props) => {
  const {
    index,
    card,
    removeSection3Card,
    handleSection3CardChange,
    modal_style,
  } = props;

  // card info
  const [card_number, setCard_number] = useState(
    card.number ? card.number : ""
  );
  const [card_text, setCard_text] = useState(card.text ? card.text : "");

  const dispatch = useDispatch();

  // modal
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleEditCard = () => {
    handleSection3CardChange(index, {
      number: card_number,
      text: card_text,
    });

    handleClose();
  };

  const handleDeleteCard = () => {
    removeSection3Card(index);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
        alignItems: "center",
        backgroundColor: " rgb(230, 230, 230)",
        padding: "1rem",
        borderRadius: "0.5rem",
        position: "relative",
        maxWidth: "14rem",
        minWidth: "8rem",
      }}
    >
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div style={modal_style}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              position: "relative",
              padding: "3rem 4rem",
            }}
          >
            <CloseIcon
              sx={{
                position: "absolute",
                top: "0.8rem",
                right: "0.8rem",
                fontSize: "1.6rem",
                cursor: "pointer",
              }}
              onClick={handleClose}
            />
            <Typography variant="h5" style={{ marginBottom: "1rem" }}>
              Editar cartão
            </Typography>

            <FormLabel>
              Número <span style={{ color: "red" }}>*</span>
              <Input
                value={card_number}
                onChange={(e) => setCard_number(e.target.value)}
                type="number"
                required
              />
            </FormLabel>
            <FormLabel sx={{ width: "24rem" }}>
              Texto <span style={{ color: "red" }}>*</span>
              <Input
                value={card_text}
                onChange={(e) => setCard_text(e.target.value)}
                sx={{ width: "24rem" }}
                as="textarea"
                required
              />
            </FormLabel>
            <Button
              variant="contained"
              onClick={handleEditCard}
              sx={{
                width: "max-content",
                alignSelf: "flex-end",
                marginTop: "1rem",
              }}
            >
              Confirmar
            </Button>
          </div>
        </div>
      </Modal>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Typography
          variant="h6"
          style={{
            color: "black",
            marginBottom: "0.2rem",
            textAlign: "center",
          }}
        >
          {card.number}
        </Typography>
        <Typography
          variant="body1"
          style={{ color: "black", textAlign: "center" }}
        >
          {card.text}
        </Typography>
      </div>
      <div
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        <SettingsIcon
          sx={{
            position: "absolute",
            left: "-0.4rem",
            top: "-0.4rem",
            padding: "0.2rem",
            fontSize: "1.6rem",
            backgroundColor: "white",
            borderRadius: "50%",
            cursor: "pointer",
            backgroundColor: "rgb(170, 170, 255)",
          }}
          onClick={handleOpen}
        />
        <CloseIcon
          sx={{
            position: "absolute",
            right: "-0.4rem",
            top: "-0.4rem",
            padding: "0.2rem",
            fontSize: "1.6rem",
            backgroundColor: "white",
            borderRadius: "50%",
            cursor: "pointer",
            backgroundColor: "rgb(255, 170, 170)",
          }}
          onClick={() => {
            if (window.confirm("Tem certeza que deseja remover esse cartão?")) {
              handleDeleteCard();
            }
          }}
        />
      </div>
    </div>
  );
};

export default Section3Card;
